import { Pipe, PipeTransform } from '@angular/core';

import { FlexTimeActivityInstance } from 'libs/domain';

@Pipe({ name: 'activityRegistered' })
export class ActivityRegisteredPipe implements PipeTransform {
  constructor() {}

  // by "showRemaining" we are distinguising between showing the remaining number of spaces and the the number of students registered
  transform(instance: FlexTimeActivityInstance, showRemaining = false): string {
    const registered = +instance.registered || 0;
    const spaces = +instance.spaces || 0;

    // if amount of spaces is 0, we count it as unlimited
    const spacesAvailable = spaces || 'Unlimited';

    if (spacesAvailable === 'Unlimited') return showRemaining ? 'Unlimited' : `${registered}`;

    const finalRegstered = showRemaining ? Math.max(spaces - registered, 0) : Math.max(registered, 0);

    return `${finalRegstered}/${spacesAvailable}`;
  }
}
